export const moduleName = `reportDocuments`